/**
 * AuthRefreshRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * AuthRefreshRes
 */
export interface AuthRefreshRes {
  /** 新的访问令牌 */
  access_token?: string
  /** 新的刷新令牌 */
  refresh_token?: string
  /** 访问令牌过期时间 */
  expire_at?: string
}

/**
 * AuthRefreshRes Schema
 */
export const AuthRefreshResSchema: SchemaDefinition = {
  properties: {
    access_token: {
      description: '新的访问令牌',
      format: 'string',
      type: 'string',
      label: '新的访问令牌',
    },
    refresh_token: {
      description: '新的刷新令牌',
      format: 'string',
      type: 'string',
      label: '新的刷新令牌',
    },
    expire_at: {
      description: '访问令牌过期时间',
      format: '*time.Time',
      type: 'string',
      label: '访问令牌过期时间',
    },
  },
  type: 'object',
}
